// ** React Imports
import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

// ** MUI Imports
import { styled } from '@mui/material/styles'
import { Grid, Button, CircularProgress, useMediaQuery } from '@mui/material'

// ** Icons Imports
import PlusIcon from 'mdi-material-ui/Plus'
import ExportIcon from 'mdi-material-ui/TrayArrowDown'
import { exportPbToSheet, exportSkusToSheet } from 'configs/axios/api_helper'

import { useDispatch, useSelector } from 'react-redux'
import { fetchPricingbooksData, pricingBooksSelector } from 'store/metaData/pricingbook'

// Styled Card component
const CustomButton = styled(Button)(({ theme }) => ({
  mx: 1,
  borderRadius: '5px !important',
  fontWeight: 600,
  color: 'common.white',
  fontSize: '0.825rem'
}))

const AddNewSub = () => {
  // ** Hooks
  const navigate = useNavigate()
  const dispatch = useDispatch() 
  const xsmall = useMediaQuery(theme => theme.breakpoints.down('sm'))
  const { pricingBooksData } = useSelector(pricingBooksSelector)

  // ** State
  const [skuLoading, setSkuLoading] = useState(false)
  const [pricingBookLoading, setPricingBookLoading] = useState(false)

  // ** Fucntions
  const redirectHandler = () => navigate('/subscriptions/new-subscription')

  const exportSkusHandler = async () => {
    setSkuLoading(true)
    try {
      // Make an API call to fetch data
      const response = await exportSkusToSheet()
      window.open(response.data.spreadsheetUrl, '_blank')
      setSkuLoading(false)
    } catch (error) {
      console.error('Error fetching or exporting data:', error)
      setSkuLoading(false)
    }
  }

  const exportDefaultPBHandler = async () => {
    setPricingBookLoading(true)

    const defaultPricingBook = pricingBooksData?.find(item => item.is_default)
    try {56
      // Make an API call to fetch data
      const response = await exportPbToSheet(defaultPricingBook.id)
      window.open(response.data.spreadsheetUrl, '_blank')
      setPricingBookLoading(false)
    } catch (error) {
      console.error('Error fetching or exporting data:', error)
      setPricingBookLoading(false)
    }
  }

  useEffect(() => {
    dispatch(fetchPricingbooksData())
  }, [])

  return (
    // eslint-disable-next-line react/react-in-jsx-scope
    <Grid item xs={10} sm={6} sx={{ whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: 5 }}>
      <Button
        variant='text'
        sx={{ fontWeight: 600, fontSize: '0.825rem', whiteSpace: 'nowrap' }}
        startIcon={<ExportIcon />}
        onClick={exportDefaultPBHandler}
        disabled={pricingBookLoading}
        endIcon={pricingBookLoading && <CircularProgress size='1rem' sx={{ color: theme => theme.palette.secondary.main }} />}
      >
        {!xsmall && 'Export Default PB'}
      </Button>
      <Button
        variant='text'
        sx={{ fontWeight: 600, fontSize: '0.825rem', whiteSpace: 'nowrap' }}
        startIcon={<ExportIcon />}
        onClick={exportSkusHandler}
        disabled={skuLoading}
        endIcon={skuLoading && <CircularProgress size='1rem' sx={{ color: theme => theme.palette.secondary.main }} />}
      >
        {!xsmall && 'Export SKUs'}
      </Button>
      <CustomButton onClick={redirectHandler} variant='contained' startIcon={<PlusIcon />}>
        New Subscription
      </CustomButton>
    </Grid>
  )
}

export default AddNewSub
